<template>
  <div>
      <b-form-group id="input-group-var-1" label="Lot:" label-size="sm" label-for="input-var-1"  label-cols="4" label-cols-lg="2">
        <b-form-select required size="sm" id="input-var-1" v-model="lot" :options="opcionsLot" @input="onUpdateLot">
           <template v-slot:first>
            <b-form-select-option :value="null">Tots</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>
  </div>
</template>

<script>
export default {
  name: "VariableLot",
  props: {
    initialValue:{      
      required: true
    }
  },  
  data() {
    return {
      codiVariable: 'lot',
      lot: null,
      opcionsLot: [
          { value: 'G3', text: 'G3' },
          { value: 'B3', text: 'B3' },
          { value: 'B6', text: 'B6' },
          { value: 'B14', text: 'B14' },
          { value: 'CLINIC', text: 'CLINIC' },
          { value: 'B5', text: 'B5' },
          { value: 'G5', text: 'G5' },
          { value: 'C2', text: 'C2' }
      ]
    };
  },
  computed:{
    returnValue(){
      let r = {codi: this.codiVariable}
      if(this.lot!=null ){
        r.valor = this.lot;
      }

      return r;
    }
  },    
  methods: {    
    onUpdateLot(newValue){
      console.log(newValue)
      if(this.returnValue.valor){
        this.$emit('variable-editada', this.returnValue)        
      }else{
        this.$emit('variable-eliminada', this.codiVariable)        
      }      
    }
  },
  mounted() {
    if(this.initialValue!=null){
      this.lot = this.initialValue.valor}
    }
};
</script>

<style>
#input-var-1{
  width: 180px;
}
</style>